<template>
  <b-modal id="editTokenModal" :title="modal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop  @hide="resetModal()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fas', 'pencil-alt']" size="1x" class="mr-2"/> {{ modal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <h6 class="element-header mb-0 text-center">{{t('editToken', 'editToken')}}</h6>
      <div class="col-12 row">
        <b-form-group
          class="col-6"
          v-if="modal.tokenData && modal.tokenData.data"
        >
          <label for="token" class="d-block text-center">{{ '*' + t('token','token') }}</label>
          <b-form-input
            id="token"
            v-model="modal.updateData.token"
            type="text"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          class="col-6"
        >
          <label for="content" class="d-block text-center">{{ '*' + t('content','content') }}</label>
          <b-form-input
            id="content"
            v-model="modal.updateData.content"
            type="text"
            required
          ></b-form-input>
        </b-form-group>
      </div>

      <div class="col-12 row">
        <div class="col-12">
          <label for="translation" class="d-block text-center">{{ '*' + t('translation','translation') }}</label>
          <b-form-textarea
            id="translation"
            v-model="modal.updateData.translation"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </div>
      </div>
      <ResponseInfo class="mt-5" v-if="(getResponseInfo.responseName == 'editTokenTranslation') && (getResponseInfo.status == 'error')"></ResponseInfo>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
        <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
          <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
        </button>
        <template >
          <button class="btn btn-primary" type="button" @click="editToken(modal.tokenData.id, modal.tokenData.language, modal.updateData, $event.target)">
            <fontAwesomeIcon :icon="['fa', 'pencil-alt']" class="text-light mr-2"/> {{ t('editTokenTranslationButtonText', 'editTokenTranslationButtonText')}}
          </button>
        </template>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'ModalEditToken',
  inject: [
    'resetModal',
    'modal',
    'editToken'
  ],
  data () {
    return {
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo'])
  },
  created() {
  },
  components:{
    ResponseInfo
  }
}
</script>

<style scoped>
.modal-open #editTokenModal___BV_modal_outer_ >>> .modal-content{
  min-width: 750px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #editTokenModal___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 450px;
  overflow-y: scroll;
}
.modal-open #editTokenModal___BV_modal_outer_ >>> .modal-dialog{
  display: flex !important;
  justify-content: center !important;
}
</style>
